/** The ceiling plan's ‹ ›: the floor's rooms in their order, the selected room's ceiling being the current one. */
type Rooms = { rooms: readonly { index: number }[] };

/** Where the selected room stands among the floor's rooms, `-1` with none selected; null on a floor without rooms. */
export function ceilingPlace(level: Rooms, roomIndex: number | null): { index: number; count: number } | null {
  if (!level.rooms.length) return null;
  return { index: roomIndex == null ? -1 : level.rooms.findIndex(room => room.index === roomIndex), count: level.rooms.length };
}

/** The room whose ceiling `step` lands on; null past the first or the last, as the wall plan's arrows stop. */
export function stepCeiling(level: Rooms, roomIndex: number | null, step: number): number | null {
  const place = ceilingPlace(level, roomIndex);
  if (!place) return null;
  const next = place.index < 0 ? (step > 0 ? 0 : -1) : place.index + step;
  return level.rooms[next]?.index ?? null;
}
